import React from 'react'

const MajorGraduationCap = props => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 15.56a1.52 1.52 0 00-.09-.28 1.264 1.264 0 00-.13-.26 2.11 2.11 0 00-.19-.23 1.584 1.584 0 00-.29-.22v-4.42a1.74 1.74 0 00-1.74-1.72h-.4l-7.39-4.27a.74.74 0 00-.76 0l-8.61 5a.75.75 0 000 1.29l1.89 1.1v4.57a2.48 2.48 0 001.29 2.15 11.11 11.11 0 005.66 1.63 12.33 12.33 0 005.89-1.63 2.51 2.51 0 001.36-2.19v-4.52l1.26-.73v3.72l-.1.06a1.41 1.41 0 00-.23.18 1.54 1.54 0 00-.42 1.07c.003.397.16.778.44 1.06.07.068.147.128.23.18.078.056.162.103.25.14.094.04.19.07.29.09.096.01.194.01.29 0a1.5 1.5 0 001.5-1.77zM11.39 5.67l4.69 2.73h-4.32a.75.75 0 00-.75.74c0 .412.328.75.74.76l6.59.05-6.94 4-7.13-4.14zm5.03 11.29a1 1 0 00.58-.87V12.4l-5.22 3a.77.77 0 01-.76 0l-5.22-3v3.7a1 1 0 00.55.86c3.29 1.94 6.49 1.93 10.07 0z"
      fill={props.fill || '#fff'}
    />
  </svg>
  )

export default MajorGraduationCap
